/* global $ */
import throttle from 'lodash.throttle';

const LOGO_SCROLL_SPREAD = 200;
const LOGO_STROKE_WIDTH = 16;
const TABLET_XL_W = 768;
const COLUMN_SCROLL_MIN = 100;

class Intro {
  constructor() {
    this.body = $('body');
    this.navLogo = $('.js-nav-logo');
    this.initialized = false;
    this.isIEOrEdge = !!(document.documentMode || /Edge/.test(navigator.userAgent));

    if (this.body.find('div.home').length) {
      this.init();
      this.navLogo.css('opacity', 0);
    }
  }

  init() {
    if (!this.initialized) {
      this.initialized = true;
      this.tagline = $('.js-tagline');
      this.taglineContainer = $('.js-tagline-container');

      this.lines = $('.js-logo-line, .js-logo-path');
      this.shapes = $('.js-logo-shape');
      this.taglineColumns = $('.js-tagline-column');
      this.taglineMasks = $('.js-tagline-mask');
      this.taglinePunctuation = $('.js-tagline-punctuation');
      this.taglineContent = $('.js-tagline-content');
      this.introMobile = $('.js-intro-mobile');

      window.addEventListener('scroll', throttle(this.onScroll, 16).bind(this));
      window.addEventListener('resize', throttle(this.onResize, 50).bind(this));

      if (this.isIEOrEdge) {
        this.body.addClass('js-ie-edge');
      } else {
        this.drawLogo();
      }
    }

    this.windowW = window.innerWidth;

    this.scrollY = 0;
    this.taglineX = 0;
    this.xOffsets = [0, 0, 0];
    this.xTargets = [0, 0, 0];
    this.columnIndex = 0;

    this.scrollToTop(); // need both
    this.setScreenSize();

    // Reset content position for calculations when resizing from mobile -> desktop
    this.taglineContent.each((i, content) => {
      $(content).css('transform', 'none');
    });

    setTimeout(() => {
      this.scrollToTop(); // need both
      this.resetPointers();
      this.setXTargets();
      this.setTaglineH();

      if (this.isSmallScreen) {
        this.taglineContent.each((i, content) => {
          $(content).css('transform', `translateX(${i * 100}%)`);
        });
      }
    }, 200);
  }

  setColumn(column) {
    this.taglineX = 0;
    this.taglineColumns.removeClass('is-active');
    this.columnIndex = column;
    this.taglineColumns.eq(this.columnIndex).addClass('is-active');
    this.tagline.css('transition', '.5s ease-in-out');

    this.taglineContent.each((i, el) => {
      $(el).css('transform', `translateX(${(column - i) * -100}%)`);
    });

    this.resetPointers();
  }

  drawLogo() {
    this.lines.each((i, el) => {
      this.drawLine(el);
    });
    setTimeout(() => {
      this.body.addClass('is-tagline');
    }, 400);
  }

  drawLine(el) {
    const length = el.getTotalLength();
    el.style.transitionDuration = 0;
    el.style.strokeDashoffset = `${length}px`;
    el.style.strokeDasharray = `${length}px`;
    setTimeout(() => {
      el.classList.add('is-drawn');
      el.style.transitionDuration = '2s';
      el.style.strokeDashoffset = `${0}px`;
      el.style.strokeDasharray = `${length}px`;
    }, 10);
  }

  scrollLine(el, spread) {
    const length = 140;
    const progress = Math.min(1, this.scrollY / spread);
    el.style.transitionDuration = '0s';
    el.style.strokeWidth = `${LOGO_STROKE_WIDTH - LOGO_STROKE_WIDTH * progress}px`;
    el.style.strokeDashoffset = `${-length * progress}px`;
  }

  onScroll() {
    this.oldScrollY = this.scrollY;
    this.scrollY = $(document).scrollTop();

    if (!this.isSmallScreen && !this.isIEOrEdge) {
      this.lines.each((i, el) => {
        this.scrollLine(el, LOGO_SCROLL_SPREAD);
      });
    }

    if (!this.xTargets) {
      return;
    }
    const progress = (this.scrollY - 14) / this.taglineScrollSpread;

    this.taglineContent.each((i, content) => {
      content.style.opacity = progress * 2 - 0.7;
    });
    this.navLogo
      .css('opacity', this.isSmallScreen ? 0 : progress * 2)
      .css('transitionDuration', '0s');

    if (this.isSmallScreen) {
      this.mobileOnScroll(progress);
    } else {
      this.desktopOnScroll(progress);
    }
    this.resetPointers();
  }

  desktopOnScroll(progress) {
    const shiftX0 = -progress * 1200;
    const shiftX1 = -progress * 300;
    const shiftX2 = progress * 550;
    const shiftY0 = 0;
    const shiftY1 = Math.max(0, progress - 0.5) * 100;
    const shiftY2 = Math.max(0, progress - 0.5) * 200;
    const x0 = Math.min(0, Math.max(this.xTargets[0], shiftX0));
    const x1 = Math.min(0, Math.max(this.xTargets[1], shiftX1));
    const x2 = Math.max(0, Math.min(this.xTargets[2], shiftX2));
    this.xOffsets = [x0, x1, x2];

    this.taglineContent.each((i, content) => {
      $(content).css('transform', 'none');
    });

    this.taglinePunctuation.each((i, symbol) => {
      symbol.style.opacity = 1 - progress * 8;
    });

    this.taglineColumns[0].style.transform = `translate(${x0}px, ${shiftY0})`;
    this.taglineColumns[1].style.transform = `translate(${x1}px, ${shiftY1}px)`;
    this.taglineColumns[2].style.transform = `translate(${x2}px, ${shiftY2}px)`;
    this.taglineMasks.css({
      'transform': 'none',
      'opacity': '1'
    });
  }

  mobileOnScroll(progress) {
    this.taglineColumns.css('transform', 'none');
    this.taglineMasks.each((i, word) => {
      if (i !== 0) {
        $(word).css('opacity', Math.max(0.2, 1 - progress));
      }
    })
    this.introMobile.css('opacity',  progress * 2 - 0.7);
  }

  resetPointers() {
    if (this.isSmallScreen && this.scrollY > COLUMN_SCROLL_MIN) {
      this.taglineColumns.each((i, column) => {
        column.style.cursor = 'pointer';
        column.style.pointerEvents = 'auto';
      });
      this.taglineColumns[this.columnIndex].style.cursor = 'auto';
      this.taglineColumns[this.columnIndex].style.pointerEvents = 'none';
    } else if (!this.isSmallScreen || this.scrollY < COLUMN_SCROLL_MIN) {
      this.taglineColumns.each((i, column) => {
        column.style.cursor = 'auto';
        column.style.pointerEvents = 'none';
      });
    }
  }

  onResize() {
    this.oldWindowW = this.windowW;
    this.windowW = window.innerWidth;
    if (window.innerWidth < 800 && window.innerWidth === this.oldWindowW) {
      return;
    }
    this.init();
  }

  setScreenSize() {
    this.isSmallScreen = this.windowW < TABLET_XL_W;
    this.margin = this.windowW * 0.03;
    this.taglineMarginBottom = this.isSmallScreen ? 60 : this.windowW / 4 + 50;
    this.taglineScrollSpread = this.isSmallScreen ? 200 : 500;
  }

  setTaglineH() {
    let taglineH;
    if (this.isSmallScreen) {
      const taglineMaskH = $('.tagline__mask').get(0).clientHeight;
      const taglineMaskSpace = 10;
      taglineH = this.taglineContent.get(0).clientHeight + this.taglineMarginBottom + taglineMaskH + taglineMaskSpace;
      this.taglineContainer.css('height', `${taglineH}px`);
      this.introMobile.find('.tagline__column').css('margin-bottom', this.taglineMarginBottom);
    } else {
      let taglineH = this.windowW * 0.55;
      this.taglineContent.each((i, content) => {
        taglineH = Math.max(taglineH, content.clientHeight + this.taglineMarginBottom);
      });
      this.taglineContainer.css('height', `${taglineH}px`);
    }
  }

  setXTargets() {
    const x0 =
      -this.taglineColumns[0].getBoundingClientRect().left + this.xOffsets[0] + this.margin;

    const oneGutterColumn = this.windowW * .03;
    const oneColumn = (this.windowW - 13 * oneGutterColumn)/ 12;

    const secondColumnLeft = this.taglineColumns[1].getBoundingClientRect().left;
    const x1 = (oneGutterColumn*5 + oneColumn*4) - secondColumnLeft;

    const thirdColumnLeft = this.taglineColumns[2].getBoundingClientRect().left;
    const x2 = (oneGutterColumn*9 + oneColumn*8) - thirdColumnLeft;

    this.xTargets = [x0, x1, x2];
  }

  scrollToTop() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  deinit() {
    window.removeEventListener('scroll', throttle(this.onScroll, 16).bind(this));
    window.removeEventListener('resize', throttle(this.onResize, 50).bind(this));
    this.body.removeClass('is-tagline');
  }
}

export default Intro;
